<template>
  <v-container
    fluid
    pa-0
    fill-height
    class="align-start"
    style="max-width: 100%"
  >
    <div class="d-flex flex-column flex-grow-1 fill-height">
      <LinkDeviationTrainDeviationTable v-if="!$apollo.loading" />
    </div>
  </v-container>
</template>

<script>
import LinkDeviationTrainDeviationTable from '@/modules/linkDeviation/components/trainDeviation/LinkDeviationTrainDeviationTable.vue'

export default {
  name: 'LinkDeviationTrainDeviation',

  components: {
    LinkDeviationTrainDeviationTable
  }
}
</script>
